export const useStyles = (theme) => ({
  root: {
    padding: 20,
    minHeight: "100vh",
  },
  body: {
    padding: 20,
    fontSize: 20,
  },
  question: {
    padding: 20,
  },
});
